module.exports = __webpack_public_path__ + "img/img-1.dbd2698c.jpg";